'use client';
import { createBrowserClient } from '@supabase/ssr';

export function createClient() {
  // Scope cookies written client-side to the root domain so they match the
  // server-side scoping (see server.ts / middleware.ts) and are never set
  // host-only on a specific subdomain. This value is derived from the
  // server-side COOKIE_DOMAIN at build time (see next.config.js), so the two
  // cannot silently diverge.
  const cookieDomain = process.env.NEXT_PUBLIC_COOKIE_DOMAIN;

  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    cookieDomain ? { cookieOptions: { domain: cookieDomain } } : undefined,
  );
}
